import { useRootStore } from './useRootStore';

/** See warning in ABTestStore */
export function useABTestStore() {
  const { abTestStore } = useRootStore();
  return abTestStore;
}
